module.exports = __webpack_public_path__ + "static/media/accessories.8f333987.jpg";